<template>
    <v-dialog v-model="dialog" width="500px">
      <v-card>
        <v-card-title class="warning headline" style="font-weight:bold; color:white">Confirm Delete</v-card-title>
        <v-card-text>Are you sure you want to remove this discount from the accommodation {{hsab.huis_code}} ?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="warning mx-2" small @click="rmHsab">Yes</v-btn>
          <v-btn color="success"  small @click="dialog = false">No</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    </template>
    
    <script>
    
    // import {bus} from "../../../main";
    
    export default {
      data() { 
        return {
          dialog: false,
          hsab_encrid: null,
          hsab: {}
        }
      },
      methods: {
        open(hsab_encrid) {
          this.$emit("showSnackbar");
          this.dialog = true;
          this.$axios
            .post("ares/json/ares/huis/hsab/getHsab.p", {
              header: {
                token: this.$session.get("ARES"),
                clientSessionId: this.$session.id(),
                request: "getHsab"
              },
              getHsab: {
                hsab_encrid: hsab_encrid
              }
            })
            .then(res => {
              if (res.data.error) {
                console.log(res.data.error);
              } else {
                this.hsab = res.data.getHsab;
              }
            })
            .finally(() => {
              this.loading = false;
            });
        },
        rmHsab() { 
          this.$axios
            .post("ares/json/ares/huis/hsab/rmHsab.p", {
              header: {
                token: this.$session.get("ARES"),
                clientSessionId: this.$session.id(),
                request: "rmHsab"
              },
              rmHsab: {
                hsab_encrid: this.hsab.hsab_encrid
              }
            })
            .then(res => {
              if (res.data.error) {
                console.log(res.data.error);
              }  else { 
                 //this.$router.reload('/huis/onHuis/' + res.data.rmHsab.huis_encrid); 
                 // bus.$emit("closeDialog", "reload");
                 //this.$refs.getHuisDiscounts();
                 this.$store.dispatch('setSnackbar', {
                  showing: true,
                  text: res.data.rmHsab.text,
                  color: res.data.rmHsab.color
                });
                this.$emit("updateData")
                this.dialog = false;
              }
            })
        },
      }
    }
    </script>
    
    